<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-07-06 13:51:57
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/components/HeaderDet/index.vue
-->
<template>
  <!-- 订单详情头部信息 -->
  <div class="header_con">
    <div class="top_1">
      <img :src="headerInfo.img" alt="" class="top_time" />
      <span class="font18 font_weight600 colof top_title line_height_25">{{
        headerInfo.title
      }}</span>
    </div>

    <!-- 需付款 (仅待付款状态且非商铺订单展示) -->
    <div
      v-if="getUserOrder.status === 10 && !isShopOrder"
      class="font12 font_weight400 colof line_height_17 ma_top"
    >
      需付款：{{ getUserOrder.total | currency(false) }}
    </div>

    <!-- 非待付款状态的内容 (如 orderConstant 或 审核上传凭证等) -->
    <div
      v-if="getUserOrder.status !== 10 && headerInfo.content"
      class="font12 font_weight400 colof line_height_17 top_total"
    >
      {{ headerInfo.content }}
    </div>

    <!-- 次级辅助内容 (如待审核的人工核对提示，或付款失败原因) -->
    <div
      v-if="getUserOrder.status !== 10 && headerInfo.subContent"
      class="font12 font_weight400 colof line_height_17 top_sub_total"
    >
      {{ headerInfo.subContent }}
    </div>

    <!-- 倒计时 (仅待付款状态、存在剩余时间且非商铺订单展示) -->
    <div
      v-if="
        getUserOrder.remainingTime && (getUserOrder.status === 10 || getUserOrder.status === -5) && !isShopOrder
      "
      class="font12 font_weight400 colof line_height_17"
    >
      <van-count-down
        :time="getUserOrder.remainingTime"
        @finish="onCountDownFinish"
      >
        <template v-slot="timeData">
          <div class="font12 font_weight400 colof line_height_17">
            剩余：<span v-if="timeData.days">{{ timeData.days }}天</span>{{ timeData.hours }}小时{{
              timeData.minutes >= 10
                ? timeData.minutes
                : "0" + timeData.minutes
            }}分{{
              timeData.seconds >= 10
                ? timeData.seconds
                : "0" + timeData.seconds
            }}秒，超出时间系统将自动取消订单
          </div>
        </template>
      </van-count-down>
    </div>

    <!-- 去支付按钮 -->
    <div
      v-if="getUserOrder.status === 10 && !isShopOrder && !hidePayButton"
      class="go_pay font14 font_weight500 line_height_34"
      @click="clickBtn"
    >
      去支付
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShopOrder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    },
    hidePayButton() {
      const order = this.getUserOrder;
      if (!order) return false;
      // 代客下单 且 跨境订单 隐藏支付按钮
      return order.kind === 10 && order.isCrossBorderOrder;
    },
    headerInfo() {
      const order = this.getUserOrder;
      if (!order) return {};

      const status = order.status;
      const deliveryMode = order.deliveryMode;

      let title = "";
      let img = require("@/assets/order/icon_time2x.png");
      let content = "";
      let subContent = "";

      if (status === 10) {
        title = this.isShopOrder ? "待支付" : "待付款";
      } else if (status === 5) {
        title = "待审核";
        content = "您的支付凭证已成功上传！";
        subContent =
          "因为核对入账人工审核，请耐心等待，您的订单核对成功后转自动转为已支付状态";
      } else if (status === -5) {
        title = "付款失败";
        img = require("@/assets/order/icon_wait@2x.png");
        content = "审核失败原因";
        subContent = order.payAuditReason || "";
      } else if (status === 11) {
        title = deliveryMode === 0 ? "待提货" : "待发货";
        content = order.orderConstant || "";
      } else if (status === 12) {
        title = "待收货";
        content = order.orderConstant || "";
      } else if (status === 13 || status === 14) {
        title = "已完成";
        img = require("@/assets/order/icon_success_result@2x.png");
        content = order.orderConstant || "";
      } else if (status === -9) {
        title = "退款中";
        content = order.orderConstant || "";
      } else if (status < 0) {
        // 订单关闭
        title = "已关闭";
        img = require("@/assets/order/icon_wait@2x.png");
        content = order.orderConstant || "";
      }

      return {
        title,
        img,
        content,
        subContent
      };
    }
  },
  methods: {
    clickBtn() {
      this.$emit("clickBtn", "去付款", this.getUserOrder.orderSn);
    },
    onCountDownFinish() {
      this.$emit("countDownFinish");
    }
  }
};
</script>

<style lang="less" scoped>
.header_con {
  .top_1 {
    font-size: 0;
    .top_time {
      width: 24px;
      vertical-align: middle;
    }
    .top_title {
      vertical-align: middle;
      margin-left: 1px;
    }
  }

  .top_total {
    margin: 5px 0;
  }
  .top_sub_total {
    margin: 4px 20px 0;
    word-break: break-all;
    text-align: center;
  }
  .ma_top {
    margin: 4px 0;
  }
  .go_pay {
    background: #fff;
    box-shadow: 2px 3px 4px 0px rgba(180, 124, 67, 0.5),
      0px -2px 2px 0px rgba(191, 146, 100, 0.5);
    border-radius: 17px;
    width: 110px;
    color: #bf9264;
    margin: 16px auto 0;
  }
}
</style>
